
  export default {
    data() {
      return {
        showMore: false,
        fullBio: `
         
          Joseph Phillips is the best-selling author and project management instructor.
          He has more than 25 years of experience as a project management consultant, educator, technology consultant, 
          business owner, and technical writer. He has consulted as a project manager for a range of businesses, 
          including startups, hospitals, architectural firms, and manufacturers.
          Joseph is passionate about helping people learn and master project management.
          He has led both in-person and virtual project management training sessions.
        `,
      };
    },
    computed: {
      truncatedBio() {
        return this.fullBio.slice(0, 150) + '...';
      },
    },
    methods: {
      toggleShowMore() {
        this.showMore = !this.showMore;
      },
    },
  };
  